import { IMAGES } from "../data/brand";

export default function Gallery() {
  const items = [
    { src: IMAGES.gallery[0], label: "Polish & Finish", span: "md:col-span-2 md:row-span-2" },
    { src: IMAGES.gallery[1], label: "Studio Shot", span: "" },
    { src: IMAGES.gallery[2], label: "Night Detail", span: "" },
    { src: IMAGES.gallery[3], label: "Microfiber Care", span: "md:col-span-2" },
  ];

  return (
    <section id="galleria" data-testid="gallery-section" className="relative py-24 md:py-32 bg-gradient-to-b from-transparent via-black to-transparent">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-nexa-blue" />
            <span className="overline">Galleria</span>
          </div>
          <div className="heading text-3xl md:text-5xl text-white leading-tight">
            Dettagli che <span className="text-nexa-blue">parlano da soli.</span>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-4 auto-rows-[220px]">
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden border border-white/10 group cursor-pointer ${it.span}`}
            >
              <img
                src={it.src}
                alt={it.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <div className="overline text-nexa-blue mb-1">Nexa Wash</div>
                <div className="heading text-white text-sm uppercase tracking-wider">{it.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
